import { OptionProps } from 'react-apollo';
import {
  CurrentUser,
  CurrentUser_userDirectory_me as Me,
} from '../../queries/CurrentUser/__generated__/CurrentUser';
import { Props } from './local';
import { RootState } from 'shared/reducers';

export { CurrentUser } from '../../queries/CurrentUser/__generated__/CurrentUser';

export interface Data {
  user?: Me;
}

export const responseToProps = ({ data }: OptionProps<Props, CurrentUser>): Data => {
  if (!data || !data.userDirectory || !data.userDirectory.me) {
    return {};
  }

  return { user: data.userDirectory.me };
};

export const isVisibleSelector = (state: RootState) => state.sharedComponents.sideMenu.visible;
